import React from 'react';
import { connect } from 'react-redux';
import { Map } from 'immutable';

import { Button, Form, OrderUnfinished, SidebarContent } from 'components';

import { setSidebar } from 'redux/reducers/app';
import { finish, setOption, startPayment, startPaymentRenew } from 'redux/reducers/orders';
import {
  canEdit,
  canRenewPayment,
  getAddress,
  getAmount,
  getChildName,
  getOrderStateMessage,
  isWaitingForOrder,
  isWaitingForPayment,
  isWithGiftcard,
} from 'redux/selectors/orders';
import { getActiveOrderId, getOrderValidation } from 'redux/selectors/app';
import { readyCheck } from 'redux/selectors/stats';
import { getProfile } from 'redux/selectors/user';

import styles from './styles.scss';
import { LANGUAGE_MAP } from '../../global';

const BOOK_PRICE = 69.95;
const COUNTRIES = LANGUAGE_MAP.filter(country => country.showSelectOption).map(country => ({
  label: global.kroostApp.strings[country.countryCode],
  value: country.selectOption,
  language: country.language,
}));

@connect(
  state => ({
    address: getAddress(state),
    amount: getAmount(state),
    canEdit: canEdit(state),
    canRenewPayment: canRenewPayment(state),
    failedValidating: state.getIn(['app', 'ui', 'failed_validating'], false),
    childName: getChildName(state),
    isWaiting: isWaitingForOrder(state),
    isWaitingForPayment: isWaitingForPayment(state),
    orderId: getActiveOrderId(state),
    paymentForwarding: state.getIn(['app', 'ui', 'payment_forwarding'], false),
    profile: getProfile(state),
    readyCheck: readyCheck(state),
    resettingState: state.getIn(['app', 'ui', 'resetting_state'], false),
    stateMessage: getOrderStateMessage(state),
    validating: state.getIn(['app', 'ui', 'validating'], false),
    validation: getOrderValidation(state),
    withGiftcard: isWithGiftcard(state),
  }),
  {
    setOption,
    startPayment,
    startPaymentRenew,
    finish,
    setSidebar,
  }
)
export default class Order extends React.PureComponent {
  constructor(p) {
    super(p);
    this.state = {
      amount: p.amount || 1,
    };
  }

  onChange = e => {
    const input = e.currentTarget;
    const { orderId, setOption } = this.props;

    const name = input.name;
    let value = input.value;

    setOption(orderId, ['address', name], value);
  };

  preventLetters = e => {
    const code = e.keyCode || e.which;
    const TAB = 9;
    const SHIFT = 16;
    const BACKSPACE = 8;

    if ((code >= 48 && code <= 57) || code === BACKSPACE || code === SHIFT || code === TAB) {
      // Accepted.
    } else {
      e.preventDefault();
    }
  };

  onAmountChange = e => {
    this.setState({ amount: e.currentTarget.value });
  };

  pay = e => {
    const { orderId, validating } = this.props;

    if (!validating) {
      this.props.startPayment(orderId);
    }
  };

  finish = () => {
    const { orderId, validating } = this.props;

    if (!validating) {
      this.props.finish(orderId);
    }
  };

  validateAmount = e => {
    let amount = e.currentTarget.value;
    const { orderId, setOption } = this.props;
    if (/^[0-9\b]+$/.test(amount) && amount >= 1 && amount <= 10) {
      setOption(orderId, ['amount'], amount);
    } else {
      setOption(orderId, ['amount'], 1);
      this.setState({ amount: 1 });
    }
  };

  renewPayment = e => {
    const { orderId, resettingState } = this.props;

    if (!resettingState) {
      this.props.startPaymentRenew(orderId);
    }
  };

  toLogin = e => {
    e.preventDefault();

    this.props.setSidebar('login');
  };

  render() {
    const {
      address,
      profile,
      validation,
      withGiftcard,
      amount,
      validating,
      failedValidating,
      paymentForwarding,
      resettingState,
      isWaitingForPayment,
      readyCheck,
      canEdit,
      canRenewPayment,
      isWaiting,
      stateMessage,
    } = this.props;

    let addressValidation = Map();
    if (validation.get('address') !== true) {
      addressValidation = validation.get('address') || addressValidation;
    }

    const showWarning = validation.get('address') !== true && addressValidation.count() > 0;
    const canPay = !paymentForwarding && !validating && !showWarning && readyCheck.all;
    const disableForm = !canEdit || paymentForwarding || resettingState;

    const notReadyMessages = [];
    if (!readyCheck.all) {
      if (!readyCheck.authenticated) {
        notReadyMessages.push(
          <li key="auth">
            {kroostApp.strings.notReadyMessagePart1}
            <a href="#" onClick={this.toLogin}>
              {kroostApp.strings.notReadyMessagePart2}
            </a>
            {kroostApp.strings.notReadyMessagePart3}
          </li>
        );
      } else if (readyCheck.uploading || readyCheck.noPhotos) {
        notReadyMessages.push(<li key="uploading">{kroostApp.strings.uploadingPhotosMessage}</li>);
      }
    }

    return (
      <SidebarContent title={kroostApp.strings.orderTitle}>
        {readyCheck.done ? (
          <form method="POST" onSubmit={this.pay}>
            {stateMessage}
            {isWaitingForPayment || canRenewPayment ? (
              <div>
                <Button cta fullWidth onClick={this.renewPayment} disabled={resettingState}>
                  {resettingState ? kroostApp.strings.loading2 : kroostApp.strings.backToPay}
                </Button>
              </div>
            ) : null}
            {!isWaitingForPayment && !canRenewPayment && !disableForm ? (
              <div>
                {/*<Form.Row>*/}
                {/*<Form.Radio name="gender"*/}
                {/*value={address.get('gender')}*/}
                {/*disabled={disableForm}*/}
                {/*options={[{*/}
                {/*'value': 'male',*/}
                {/*'label': 'Dhr'*/}
                {/*},{*/}
                {/*'value': 'female',*/}
                {/*'label': 'Mvr'*/}
                {/*}]}*/}
                {/*onChange={this.onChange} />*/}
                {/*</Form.Row>*/}
                <input type="hidden" name="gender" value="Mvr" />

                <Form.Row>
                  <p>{kroostApp.strings.orderIntro}</p>
                </Form.Row>

                <Form.Row>
                  <Form.Input
                    name="first_name"
                    className={styles.hideRequirementMarker}
                    type="text"
                    label={kroostApp.strings.signupFirstNamePlaceholder}
                    value={address.get('first_name')}
                    invalid={addressValidation.get('first_name', '') !== ''}
                    onChange={this.onChange}
                  />
                  <input type="hidden" name="middle_name" value="" />
                </Form.Row>
                <Form.Row>
                  <Form.Input
                    name="last_name"
                    type="text"
                    className={styles.hideRequirementMarker}
                    label={kroostApp.strings.surname}
                    required
                    value={address.get('last_name')}
                    invalid={addressValidation.get('last_name', '') !== ''}
                    onChange={this.onChange}
                  />
                </Form.Row>

                <Form.Row>
                  <Form.Input
                    name="street_name"
                    type="text"
                    label={kroostApp.strings.street}
                    required
                    className={styles.hideRequirementMarker}
                    value={address.get('street_name')}
                    invalid={addressValidation.get('street_name', '') !== ''}
                    onChange={this.onChange}
                  />
                </Form.Row>
                <Form.Row>
                  <Form.Input
                    name="street_nr"
                    type="text"
                    className={styles.hideRequirementMarker}
                    label={kroostApp.strings.houseNumber}
                    required
                    title={kroostApp.strings.houseNumber}
                    value={address.get('street_nr')}
                    invalid={addressValidation.get('street_nr', '') !== ''}
                    onChange={this.onChange}
                  />
                </Form.Row>

                <Form.Row>
                  <Form.Input
                    name="zipcode"
                    type="text"
                    label={kroostApp.strings.postCode}
                    className={styles.hideRequirementMarker}
                    required
                    value={address.get('zipcode')}
                    invalid={addressValidation.get('zipcode', '') !== ''}
                    onChange={this.onChange}
                  />
                </Form.Row>

                <Form.Row>
                  <Form.Input
                    name="city"
                    type="text"
                    label={kroostApp.strings.city}
                    required
                    className={styles.hideRequirementMarker}
                    value={address.get('city')}
                    invalid={addressValidation.get('city', '') !== ''}
                    onChange={this.onChange}
                  />
                </Form.Row>
                <Form.Row>
                  <Form.Select
                    name="country"
                    type="text"
                    label={kroostApp.strings.country}
                    className={styles.hideRequirementMarker}
                    required
                    value={address.get('country')}
                    options={COUNTRIES}
                    invalid={addressValidation.get('country', '') !== ''}
                    onChange={this.onChange}
                  />
                </Form.Row>

                <Form.Row>
                  <Form.Input
                    name="phone"
                    hide={true}
                    type="phone"
                    className={styles.hideRequirementMarker}
                    label={kroostApp.strings.phone}
                    value={address.get('phone')}
                    invalid={addressValidation.get('phone', '') !== ''}
                    onChange={this.onChange}
                  />
                </Form.Row>

                {profile && profile.get('email') ? (
                  <input type="hidden" name="email" value={profile.get('email')} />
                ) : null}

                {!withGiftcard ? (
                  <Form.Row>
                    <Form.Input
                      name="amount"
                      type="number"
                      label={kroostApp.strings.amount}
                      value={amount}
                      className={styles.hideRequirementMarker}
                      onBlur={this.validateAmount}
                      onChange={this.onAmountChange}
                      onKeyDown={this.preventLetters}
                    />
                  </Form.Row>
                ) : null}

                {/*<div className={styles.divider} />*/}

                {!notReadyMessages.all && !isWaiting && notReadyMessages.length ? (
                  <Form.Error>
                    <ul>{notReadyMessages}</ul>
                  </Form.Error>
                ) : null}

                {!canEdit && !canRenewPayment && !isWaiting && !isWaitingForPayment ? (
                  <Form.Error>{kroostApp.strings.warningMessageBeforeForNoChanges}</Form.Error>
                ) : null}

                {showWarning || failedValidating ? (
                  <Form.Error>{kroostApp.strings.fillTheFieldsMessage}</Form.Error>
                ) : null}

                {withGiftcard ? (
                  canEdit ? (
                    <Form.Row className={styles.actions}>
                      <Button cta className={styles.submit} onClick={this.finish} disabled={validating || !canPay}>
                        {validating ? kroostApp.strings.checking2 : kroostApp.strings.orderComplete}
                      </Button>
                    </Form.Row>
                  ) : null
                ) : canRenewPayment || isWaitingForPayment || canEdit ? (
                  <Form.Row className={styles.actions}>
                    <Button cta className={styles.submit} onClick={this.pay} disabled={validating || !canPay}>
                      {validating ? kroostApp.strings.checking2 : kroostApp.strings.orderComplete}
                    </Button>
                  </Form.Row>
                ) : null}
              </div>
            ) : null}
          </form>
        ) : (
          <OrderUnfinished />
        )}
      </SidebarContent>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/order/index.js